// src/store/index.js
import { configureStore } from "@reduxjs/toolkit";
import { rtkQueryErrorLogger } from "./rtkQueryErrorLogger";

import authReducer from "./authSlice";
import tenantReducer from "./tenantSlice";
import contactFormReducer from "./contactFormSlice";
import notificationReducer from "./notificationSlice";
import catalogReducer from "./catalogSlice";
import globalAdminReducer from "../features/portal/globalAdminSlice";
import tenantJsonEditorReducer from "../features/portal/tenant-management/tenantJsonEditorSlice";
import crmReducer from "../features/portal/crm/crmSlice";
// FIX: Importación normalizada desde la carpeta store
import documentsReducer from "./documentsSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    tenant: tenantReducer,
    contactForm: contactFormReducer,
    notifications: notificationReducer,
    catalog: catalogReducer,
    globalAdmin: globalAdminReducer,
    crudTenant: tenantJsonEditorReducer,
    crm: crmReducer,
    documents: documentsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(rtkQueryErrorLogger),
});

export default store;
